(function () {
  var gaId = 'G-FPYVGE3XRY';
  var gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
  document.head.appendChild(gtagScript);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', gaId, { send_page_view: false });

  var lastHref = location.href;
  function gaPageView() {
    gtag('event', 'page_view', {
      page_location: location.href,
      page_title: document.title,
      send_to: gaId,
    });
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) gaPageView();
  });
  setInterval(function () {
    if (location.href !== lastHref) {
      lastHref = location.href;
      gaPageView();
    }
  }, 400);
})();
